import React, { Component } from "react"
import { connect } from "react-redux"
import Menu from "components/menu"
import config from "./config"

class UsefulLinks extends Component {
  render() {
    return <Menu {...config} {...this.props} />
  }
}

const mapStateToProps = state => {
  return {
    messages: state.intl.messages.containers.features.usefulLinks,
    usefulLinks: state.reducers.usefulLinks
  }
}

export default connect(mapStateToProps)(UsefulLinks)
